export var CHAT_OPEN_CLASS = "edge-tier-chat-open";
export var PROACTIVE_CHAT_OPEN_CLASS = "edge-tier-proactive-chat-open";
export var ROOT_ID = "root";
export var PROACTIVE_CHAT_ROOT_ID = "proactive-chat-root";
export var CHAT_FRAME_NAME = "chat-frame";
export var PROACTIVE_CHAT_FRAME_NAME = "proactive-chat-frame";
export var SOCKET_NAMESPACE = "chat";
export var FRAME_STORAGE_NAME = "EdgeTierFrames";
// Fallback language when a translation or something is missing.
export var DEFAULT_LANGUAGE_ID = 11;
//# sourceMappingURL=string-constants.js.map